import React, { Component } from 'react'
import {InputGroup, InputGroupAddon, InputGroupText} from 'reactstrap';
import Select from 'react-select';
import Tooltip from './Tooltip';

export class FieldFile extends Component {

  render() {
    let { meta: { error }, input: {name, onChange}, accept} = this.props;
    return (
      <div style={{'padding': '5px 0 5px 0'}}>
        <input type="file" onChange={onChange} name={name} accept={accept}/>
        {onChange && error && <em className="error invalid-feedback">{error}</em>}
      </div>
    )
  }
}

export class ModalSelect extends Component {
  render() {
    let { error} = this.props;
    const Aux = props => props.children;
    return (
      <Aux>
        <Select {...this.props}/>
        {error && <em className="error invalid-feedback">{error}</em>}
      </Aux>
    )
  }
}

export class FieldText extends Component {

  render() {
    let { meta: { touched, error }, input, initValue, placeholder, type, className, wrapClassName, tooltip} = this.props;
    let inputClass = (touched && error) ? (className || '') + " form-control is-invalid " : "form-control "
    if (className) {
      inputClass += className;
    }
    if (initValue && !input.value){
      input.value = initValue;
    }
    
    const hasError = touched && error
    const noError = !touched || !error
    return (
      <div className={`mb-12 ${wrapClassName}`}>
        {hasError && (
          <Tooltip content={error} position='top' trigger='click'>
            <input {...input} autoComplete="off" type={type} placeholder={placeholder} className={inputClass} />
          </Tooltip>
        )}
        {(!hasError && tooltip) && (
          <Tooltip content={tooltip} position='top' trigger='click'>
            <input {...input} autoComplete="off" type={type} placeholder={placeholder} className={inputClass} />
          </Tooltip>
        )}
        {(!hasError && !tooltip) && (
          <input {...input} autoComplete="off" type={type} placeholder={placeholder} className={inputClass} />
        )}
      </div>
    )
  }
}

export class MoneyField extends Component {
  render() {
    let { meta: { touched, error }, input, title, initValue, placeholder, type, className} = this.props;
    let inputClass = (touched && error) ? "form-control is-invalid price " : "form-control price "
    if (className) {
      inputClass += className;
    }
    if (initValue && !input.value){
      input.value = initValue;
    }
    
    return (
      <InputGroup className="mb-3">
        <input type={type} {...input} placeholder={placeholder} title={title} className={inputClass}/>
        {(this.props.icon || this.props.iconText) && (
          <InputGroupAddon addonType="append">
            <InputGroupText>
              <i className={this.props.icon}>{this.props.iconText}</i>
            </InputGroupText>
          </InputGroupAddon>
        )}
        {touched && error && <em className="error invalid-feedback">{error}</em>}
      </InputGroup>
    )
  }
}

export class RegisterField extends Component {
  render() {
    let { meta: { touched, error }} = this.props;
    const inputClass = (touched && error) ? "form-control is-invalid" : "form-control"
    return (
      <InputGroup className="mb-3">
        <InputGroupAddon addonType="prepend">
          <InputGroupText>
            <i className={this.props.icon}>{this.props.iconText}</i>
          </InputGroupText>
        </InputGroupAddon>
        <input autoComplete="off" type={this.props.type} {...this.props.input} placeholder={this.props.placeholder} className={inputClass} />
        {touched && error && <em className="error invalid-feedback">{error}</em>}
      </InputGroup>
    )
  }
}

export class LoginField extends Component {
  render() {
    let { meta: { touched, error }} = this.props;
    const inputClass = (touched && error) ? "form-control is-invalid" : "form-control"
    return (
      <InputGroup className="mb-3">
        <InputGroupAddon addonType="prepend">
          <InputGroupText>
            <i className={this.props.icon}>{this.props.iconText}</i>
          </InputGroupText>
        </InputGroupAddon>
        <input autoComplete="off" type={this.props.type} {...this.props.input} placeholder={this.props.placeholder} className={inputClass} />
        {touched && error && <em className="error invalid-feedback">{error}</em>}
      </InputGroup>
    )
  }
}

export default RegisterField


// WEBPACK FOOTER //
// ./src/views/controls/_FieldValication.js